<template>
  <div class="page">
    <wk-search
        class="wrapBox"
        :search-control-data="searchControlData"
        @search="search($event)"
    ></wk-search>
    <div class="wrapBox">
      <div class="flex justify-space-between" style="margin-bottom: 10px">
        <div style="line-height: 40px">共{{ total }}条数据</div>
        <div class="flex">
          <el-button class="common-button margin-r8" v-auth="permission.RECOMMEND_APP_ADD" @click="addBanner">
            添加
          </el-button>
          <el-upload
              v-auth="permission.RECOMMEND_APP_IMPORT"
              :show-file-list="false"
              :action="configBaseURL + '/api/recommendApk/import'"
              :data="{ token: token}"
              accept=".xls, .xlsx"
              :on-success="handleSuccess"
              :on-error="handleError"
          >
            <el-button class="common-button" type="primary">批量导入</el-button>
          </el-upload>
        </div>
      </div>
      <el-table
          class="tableBox"
          :data="tableData"
          stripe
          v-auth="permission.RECOMMEND_APP_LIST"
          style="width: 100%">
        <el-table-column
            width="60"
            align="center"
            type="index"
            label="序号">
        </el-table-column>
        <el-table-column
            align="center"
            prop="apkName"
            label="应用名称">
        </el-table-column>
        <el-table-column
            align="center"
            prop="apkPackage"
            label="应用包名">
        </el-table-column>
        <el-table-column
            align="center"
            prop="isGold"
            width="80"
            label="是否金标">
          <template slot-scope="scope">
            <span>{{ scope.row.isGold == 1 ? '是' : '否' }}</span>
          </template>
        </el-table-column>

        <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | parseTime() }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button v-auth="permission.RECOMMEND_APP_DELETE" class="color-blue link-button" type="text"
                       @click="deleteClick(scope.row.id)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="text-right margin-t30">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchFormData.perPage"
            :current-page="searchFormData.page"
            layout="total, prev, pager, next, sizes"
            :total="total"
        ></el-pagination>
      </div>
    </div>
    <info ref="modalRef" @search="search"></info>
  </div>
</template>
<script>
import info from "./dialogs/info";

export default {
  components: {info},
  data() {
    return {
      token: localStorage.getItem('Token') ? localStorage.getItem('Token') :  '',
      total: 0,
      dialogVisible: false,
      loading: false,
      searchFormData: {
        page: 1,
        perPage: 10,
      },
      searchControlData: [
        {
          type: 'input',
          label: '应用名称',
          placeholder: '请输入应用名称',
          key: 'apkName'
        },
        {
          type: 'input',
          label: '应用包名',
          placeholder: '请输入应用包名',
          key: 'apkPackage'
        },
        {
          type: 'select',
          label: '是否金标',
          placeholder: '请选是否金标',
          key: 'isGold',
          option: [
            {
              label: '全部',
              value: ''
            },
            {
              label: '是',
              value: '1'
            },
            {
              label: '否',
              value: '2'
            },
          ]
        },
      ],
      tableData: [],
    }
  },
  created() {
    this.search()
  },
  methods: {
    search(data) {
      this.loading = true
      if (data) {
        Object.assign(this.searchFormData, data)
        this.searchFormData.page = 1
      }
      this.$apis.recommendAppServer.queryList(this.searchFormData).then(res => {
        if (res['code'] == 0 && res.data.data) {
          this.total = res.data.total
          this.tableData = res.data.data
        } else {
          this.total = 0
          this.tableData = []
        }
        this.loading = false
      })
    },
    addBanner() {
      this.$refs.modalRef.show('add')
    },
    deleteClick(id) {
      this.$confirm('删除后无法恢复，请谨慎操作', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'cancelButton',
        confirmButtonClass: 'confirmButton',
        type: 'info ',
        center: true
      }).then(() => {
        this.$apis.recommendAppServer.deleteRecommendApp({
          id: id
        }).then(res => {
          if (res['code'] == 0) {
            this.search()
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
        })
      })
    },
    handleSizeChange(val) {
      this.searchFormData.perPage = val
      this.search()
    },
    handleCurrentChange(val) {
      this.searchFormData.page = val
      this.search()
    },
    handleSuccess(response) {
      if (response.code === 0) {
        this.$message.success('导入成功')
        this.search()
      } else {
        this.$message.error(response.message || '导入失败')
      }

    },
    handleError(error) {
      this.$message.error('导入失败')
    }
  }
}
</script>
<style>
.el-message-box--center .el-message-box__message {
  font-size: 20px;
  color: #000000;
}

.cancelButton {
  width: 98px;
  margin-left: 14px;
}

.confirmButton {
  width: 98px;
}
</style>
<style scoped lang="scss">
.el-message-box--center .el-message-box__message {
  font-size: 20px;
  color: #000000;
}

.page {
}
</style>
